import { StripeInfo } from '@type/db-types';
import { createContext, useContext } from 'react';

export interface StripeAccountContextValues {
    loading: boolean;
    watchingStripeAccount: boolean;
    stripeInfo: StripeInfo | undefined | null;
    stripeAccountRequired: () => void;
    refreshStripeInfo: () => void;
    error: string;
}

export const StripeAccountContext = createContext<StripeAccountContextValues>({
    loading: true,
    stripeInfo: undefined,
    stripeAccountRequired: () => undefined,
    refreshStripeInfo: () => undefined,
    watchingStripeAccount: false,
    error: '',
});

// make sure user's stripe account is set up
const useStripeAccount = () => {
    const ctx = useContext(StripeAccountContext);

    if (!ctx) console.error('useStripeAccount called outside of StripeAccountProvider Context');

    return ctx;
};

export default useStripeAccount;
